<template>
  <div class="wrapper">
    <v-layout justify-center>
      <v-snackbar
          v-model="show_flash"
          :timeout="9000"
          color=""
          :top="true"

      >
        {{ flash_message }}
        <v-btn
            text
            @click="show_flash = false"
        >
          Close
        </v-btn>
      </v-snackbar>
      <v-container
          grid-list-md text-xs-center
      >
        <v-layout row wrap pa-2>

          <template>

            <v-flex xs8>
              <v-container>
                <h2>
                  {{ $t(customer.name) }}'s {{ $t('Favorite Drinks') }}
                </h2>
                <v-row>
                  <v-col cols="12" v-for="(product, index) in customer.products" sm="4" md="3"
                         :key="index"
                  >
                    <v-card @click="add_product_to_cart(product)">
                      <v-card-text>

                        {{ $t(product.category.name) }}
                        {{ $t(product.name) }}

                        <span v-if="product.attribute_value">
                                                        - {{ product.attribute_value.name }}
                                                    </span>
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" v-for="(attribute, index) in customer.attribute_values" sm="4"
                         md="3"
                         :key="index"
                  >
                    <v-card @click="add_attribute_to_cart(attribute)">
                      <v-card-text>
                        {{ attribute.product.name }} <br>
                        {{ attribute.name }}
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <v-btn
                        color="grey darken-4"
                        block
                        @click="$router.push(`/c-panel/invoices/${customer.id}`)"
                    >
                      {{ $t('INVOICES') }}
                    </v-btn>
                  </v-col>
                </v-row>
              </v-container>
            </v-flex>
            <v-flex xs4>
              <v-card class="px-4 mx-auto" po-3>
                <v-layout py-4
                          pl-4>
                  <v-flex xs12>
                    <h4>
                      {{ $t('Orders') }} <span v-show="customer.credit.credit && customer.credit.credit > 0">
                                            | Has {{ customer.credit.credit }} credit
                                        </span>
                    </h4>
                    <v-simple-table dense>
                      <thead>
                      <tr>
                        <th class="text-left">{{ $t('Product') }}</th>
                        <th class="text-left">{{ $t('QTY') }}</th>
                        <th class="text-left">{{ $t('PRICE') }}</th>
                        <th class="text-left">{{ $t('Actions') }}</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr
                          style="cursor: pointer;"
                          v-bind:class="{'yellow darken-3': ci.hour_diff > 13}"
                          v-for="(ci, index) in cart_items"
                          :key="index"
                          @click="openTableDialog(ci.id)"
                      >
                        <td class="pa-2" style="border-bottom: 1px solid #cccccc;">
                          {{ $t(ci.category) }} {{ $t(ci.name) }}
                          <br>
                          {{ ci.options }}

                          <span v-if="ci.table_number">
                            Table No: {{ ci.table_number }}
                          </span>
                          <div v-if="ci.is_food_order">
                            {{ $t('Sent to kitchen') }}: {{ ci.food_order_confirmed }}
                          </div>
                        </td>
                        <td style="border-bottom: 1px solid #cccccc;">{{ ci.qty }}</td>
                        <td style="border-bottom: 1px solid #cccccc;">{{ ci.price }}</td>
                        <td style="border-bottom: 1px solid #cccccc;">
                          <v-btn
                              v-show="ci.hour_diff < 13"
                              color="blue-grey darken-4"
                              @click.stop="delete_order(ci)"
                              text
                              fab
                              small
                          >
                            <v-icon>
                              mdi-delete
                            </v-icon>
                          </v-btn>
                        </td>
                      </tr>
                      <tr v-for="(ci, index) in order_freebies" :key="index + '-'+ci.id">
                        <td>
                          {{ $t(ci.category) }}
                          {{ $t(ci.name) }}
                        </td>
                        <td>{{ ci.qty }}</td>
                        <td>{{ ci.price }}</td>
                        <td>
                          <v-btn
                              color="blue-grey darken-4"
                              @click="delete_order(ci)"
                              text
                              fab
                              small
                          >
                            <v-icon>
                              mdi-delete
                            </v-icon>
                          </v-btn>
                        </td>
                      </tr>
                      <tr>
                        <td colspan="2" class="text-right">
                          {{ $t('TOTAL') }}:
                        </td>
                        <td>
                          {{ total_cart }}
                        </td>
                      </tr>
                      </tbody>
                    </v-simple-table>

                    <v-spacer></v-spacer>


                  </v-flex>


                </v-layout>
                <v-layout py-4
                          pl-4>
                  <v-flex xs12 v-show="free_items.length">
                    <h4>
                      {{ $t('Free Drinks Remaining') }}
                    </h4>
                    <v-simple-table dense>
                      <thead>
                      <tr>
                        <th class="text-left">{{ $t('Product') }}</th>
                        <th class="text-left">{{ $t('QTY') }}</th>
                        <th class="text-left">{{ $t('Actions') }}</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="(ci, index) in free_items" :key="index">
                        <td>
                          {{ $t(ci.product.category.name) }}
                          {{ $t(ci.product.name) }}
                          <span v-if="ci.attribute_value">
                                                        - {{ $t(ci.attribute_value.name) }}
                                                    </span>
                        </td>
                        <td>1</td>
                        <td>
                          <v-btn
                              color="blue-grey darken-4"
                              class="black--text"
                              @click="delete_free_drink(ci)"
                              text
                              fab
                              small
                          >
                            <v-icon>
                              mdi-delete
                            </v-icon>
                          </v-btn>
                        </td>
                      </tr>
                      </tbody>
                    </v-simple-table>
                  </v-flex>


                </v-layout>
                <v-layout py-4
                          pl-4>
                  <v-flex xs12>
                    <v-btn
                        v-show="cart_items.filter(o => o.is_food_order && !o.food_order_confirmed).length"
                        :disabled="cart_items.length < 1 && order_freebies.length < 1"
                        color="grey darken-4 mb-4"
                        block
                        @click="confirm_food_orders(customer)"
                    >
                      <v-icon>
                        mdi-food
                      </v-icon>
                      {{ $t('Confirm Food Orders') }}
                    </v-btn>

                    <v-btn
                        v-show="cart_items.filter(o => o.food_order_confirmed).length"
                        color="grey darken-4 mb-4"
                        block
                        @click="openFoodOrderPrintDialog()"
                    >
                      <v-icon>
                        mdi-food
                      </v-icon>
                      {{ $t('Print Food Orders') }}
                    </v-btn>

                    <v-btn
                        :disabled="cart_items.length < 1 && order_freebies.length < 1"
                        color="grey darken-4"
                        block
                        @click="load_orders(customer)"
                    >
                      <v-icon>
                        mdi-cart
                      </v-icon>
                      {{ $t('Checkout') }}
                      <sup>
                        ({{ cart_items.length }})
                      </sup>
                    </v-btn>
                  </v-flex>
                </v-layout>


              </v-card>
            </v-flex>

          </template>

        </v-layout>
      </v-container>
    </v-layout>

    <v-container>
      <v-row>

        <v-col v-for="q in qtys" cols="1" sm="1" md="1">
          <v-btn
              small
              rounded
              outlined
              v-bind:class="{'success':qty === q}"
              color="blue-grey darken-4"
              @click="qty = q"
          >
            {{ q }}
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
    <v-container>
      <h2 v-show="selected_category !== ''">
        {{ $t(selected_category.name) }}
      </h2>
      <v-breadcrumbs>
        <v-breadcrumbs-item v-if="validHistory.length && validHistory[0].id">
          <v-icon @click="load_category_history({})">mdi-home</v-icon>
          <span class="pl-3 px-1">/</span>
        </v-breadcrumbs-item>
        <template v-for="(item, index) in validHistory">
          <v-breadcrumbs-item
              :disabled="selected_category.id === item.id"
              @click="selected_category.id !== item.id ? load_category_history(item) : null"
              :style="selected_category.id === item.id ? '' : 'cursor: pointer'"
          >
            {{ item.name }}
          </v-breadcrumbs-item>

          <span
              v-if="index < validHistory.length - 1"
              :key="`divider-${item.id}`"
              class="px-1"
          >
          /
        </span>
        </template>
      </v-breadcrumbs>

      <v-row>
        <v-col cols="12" sm="6" md="4" v-for="category in categories">
          <v-card @click="load_categories(category)">
            <v-card-text class="px-4">
              {{ $t(category.name) }}
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <v-row v-show="!sizes.length && !mixes.length">
        <v-col cols="12" sm="6" md="4" v-for="product in selected_category.products">
          <v-card v-if="!product.sizes.length && !product.mixes.length"
                  @click="add_product_to_cart(product)">
            <v-card-text class="px-4">
              {{ $t(product.name) }}
            </v-card-text>
          </v-card>

          <v-card v-if="product.sizes.length || product.mixes.length"
                  @click="load_attributes(product)">
            <v-card-text class="px-4">
              {{ $t(product.name) }}
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>


      <v-container v-show="sizes.length || mixes.length">

        <v-row>
          <v-col cols="12" sm="6" md="4" v-for="size in sizes">
            <v-card
                @click="add_attribute_to_cart(size)">
              <v-card-text class="px-4">
                {{ $t(size.name) }}
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" sm="6" md="4" v-for="mix in mixes">
            <v-card
                @click="add_attribute_to_cart(mix)">
              <v-card-text class="px-4">
                {{ mix.name }}
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>

      </v-container>
    </v-container>
    <v-container>
      <v-row>
        <v-col cols="12" sm="6" md="4">
          <v-card @click="load_customers()"
                  color="blue-grey darken-4 "
                  class="px-4">
            <v-card-text class="white--text">
              {{ $t('End') }}
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <v-dialog v-model="table_dialog" max-width="500px">
      <v-card>
        <v-card-title>
          {{ $t('Additional Options') }}
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col
                  v-for="n in 32"
                  :key="n"
                  cols="2"
                  sm="2"
                  md="2"
              >
                <v-btn
                    small
                    rounded
                    outlined
                    v-bind:class="{'success':selectedCartItem.table_number === n}"
                    color="blue-grey darken-4"
                    @click="selectedCartItem.table_number = n"
                >
                  {{ n }}
                </v-btn>
              </v-col>
            </v-row>
            <v-row>
              <v-col v-if="selectedCartItem.orderId && table_dialog">
                <v-card class="pa-4 rounded-lg" outlined>
                  <!-- Available Tags Section -->
                  <div v-if="selectedCartItem.tags.length">
                    <div class="text-h6 font-weight-medium mb-3 primary--text">Available Tags</div>
                    <div class="d-flex flex-wrap">
                      <v-btn
                          v-for="(tag, index) in selectedCartItem.tags"
                          :key="index"
                          class="ma-1"
                          small
                          outlined
                          color="primary"
                          @click="selectedCartItem.extras.push(tag)"
                      >
                        <v-icon left small>mdi-tag</v-icon>
                        {{ tag.name }}
                        <span v-if="tag.amount" class="ml-1 font-weight-bold"> + {{ tag.amount.toFixed(2) }}</span>
                      </v-btn>
                    </div>
                  </div>
                  <v-alert v-else type="info" text dense>
                    No tags available for this order
                  </v-alert>

                  <!-- Divider if both sections are present -->
                  <v-divider v-if="selectedCartItem.tags.length && selectedCartItem.extras.length"
                             class="my-4"></v-divider>

                  <!-- Selected Extras Section -->
                  <div v-if="selectedCartItem.extras.length" class="mt-4">
                    <div class="text-h6 font-weight-medium mb-3 success--text">Selected Extras</div>
                    <div class="d-flex flex-wrap">
                      <v-chip
                          v-for="(extra, index) in selectedCartItem.extras"
                          :key="index"
                          class="ma-1"
                          color="success"
                          outlined
                          close
                          @click:close="selectedCartItem.extras.splice(index, 1)"
                      >
                        <v-icon left small>mdi-check</v-icon>
                        {{ extra.name }}
                        <span v-if="extra.amount" class="ml-1 font-weight-bold"> + {{ extra.amount.toFixed(2) }}</span>
                      </v-chip>
                    </div>
                  </div>
                </v-card>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-btn color="blue darken-1" text @click="table_dialog = false">Cancel</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="saveExtras(selectedCartItem)">Save</v-btn>

        </v-card-actions>

      </v-card>
    </v-dialog>

    <!-- Add this dialog component to your template -->
    <v-dialog v-model="showOptionsDialog" max-width="500px">
      <v-card>
        <v-card-title class="headline">
          Select Options
        </v-card-title>

        <v-card-text v-if="current_product">
          <div v-if="optionSelectionError" class="error--text mb-4">
            {{ optionSelectionError }}
          </div>

          <div v-for="(section, index) in selectedOptions" :key="index" class="mb-4">
            <div class="subtitle-1 font-weight-bold mb-2">
              {{ section.title }}
            </div>

            <v-radio-group
                v-model="option_selections[section.step]"
                :mandatory="true"
                row
            >
              <v-radio
                  v-for="(option, optIndex) in current_product.options[section.step].options"
                  :key="optIndex"
                  :label="option.name"
                  :value="option"
              ></v-radio>
            </v-radio-group>
          </div>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey darken-1" text @click="showOptionsDialog = false">
            Cancel
          </v-btn>
          <v-btn color="primary" text @click="submitProductWithOptions">
            Add to Cart
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="printFoodOrderDialog" max-width="500px">
      <v-card>
        <v-card-title>
          {{ $t('Select Food Orders to Print') }}
          <v-spacer></v-spacer>
          <v-checkbox
              v-model="selectAll"
              :label="$t('Select All')"
              @change="toggleSelectAll"
              hide-details
          ></v-checkbox>
        </v-card-title>

        <v-divider></v-divider>

        <v-card-text style="max-height: 400px; overflow-y: auto;">
          <v-list>
            <v-list-item
                v-for="(item, index) in allFoodOrders"
                :key="item.id"
            >
              <v-list-item-action>
                <v-checkbox
                    v-model="selectedFoodOrders"
                    :value="item"
                    hide-details
                ></v-checkbox>
              </v-list-item-action>

              <v-list-item-content>
                <v-list-item-title>
                  <span class="font-weight-bold">{{ item.qty }}x</span> {{ item.name }}
                </v-list-item-title>
                <v-list-item-subtitle>
                  {{ item.category }}
                  <div v-if="item.extras && item.extras.length">
                <span v-for="extra in item.extras" :key="extra.name" class="pl-2">
                  + {{ extra.name }}
                </span>
                  </div>
                  <div v-if="item.product_tags && item.product_tags.length">
                <span v-for="tag in item.product_tags" :key="tag.name" class="pl-2">
                  {{ tag.amount === 0 ? '- ' : '+ ' }}{{ tag.name }}
                </span>
                  </div>
                  <div v-if="item.options" class="pl-2">
                    {{ item.options }}
                  </div>
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
              color="grey lighten-1"
              text
              @click="printFoodOrderDialog = false"
          >
            {{ $t('Cancel') }}
          </v-btn>
          <v-btn
              color="green darken-1"
              text
              @click="printSelectedKitchenOrders"
              :disabled="selectedFoodOrders.length === 0"
          >
            {{ $t('Print') }} ({{ selectedFoodOrders.length }})
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>
import EditData from '../../../components/c-panel/EditData.vue'

export default {
  components: {
    EditData
  },
  mounted() {

    // this.$i18n.locale = 'en'

  },
  data() {
    return {
      selectAll: false,
      printFoodOrderDialog: false,
      selectedFoodOrders: [],
      allFoodOrders: [],
      products: [],
      show_flash: false,
      flash_message: '',
      selected_category: {},
      flash_type: 'success',
      edit_title: '',
      customer_id: 0,
      customer: {credit: {}},
      cart_count: 0,
      checkoutmenu: false,
      cart_items: [],
      free_items: [],
      total_cart: 0,
      staff_id: 0,
      mix_dialog: false,
      categories: [],
      default_product_mixes: {
        init_product: {},
        mixes: []
      },
      product_mixes: {
        init_product: {},
        mixes: []
      },
      product_dialog: false,
      category: {},
      sizes: [],
      mixes: [],
      order_freebies: [],
      qty: 1,
      qtys: [
        1, 2, 3, 4, 5, 6, 7, 8, 9, 10
      ],
      overlay: false,
      table_dialog: false,
      selected_order_id: null,
      selectedCartItem: {
        orderId: null,
        tags: [],
        extras: [],
        table_number: null
      },
      showOptionsDialog: false,
      option_selections: {},
      current_product: null,
      optionSelectionError: null,
      history: [],
      base_categories: [],
    }
  },
  created() {
    this.staff_id = parseInt(this.$route.params.staff_id);
    this.customer_id = parseInt(this.$route.params.customer_id);
    // this.load_products();
    this.load_categories('');

    let language_id = localStorage.getItem('language_id');
    console.log('lang: ' + language_id);
    let language = 'en';
    if (language_id) {
      language = language_id;
    } else {
      let chinese_staff_ids = [3, 7, 8];
      if (chinese_staff_ids.includes(this.staff_id)) {
        language = 'zh';
      }
    }
    this.$i18n.locale = language;

  },
  computed: {
    validHistory() {
      return this.history.filter(item => typeof item === 'object' && item !== null);
    },
    selectedOptions() {
      if (this.current_product && this.current_product.options && this.current_product.options.length) {
        return this.current_product.options;
      }
      return [];
    }
  },
  methods: {
    openFoodOrderPrintDialog() {
      // Get all confirmed food orders
      this.allFoodOrders = this.cart_items.filter(o => o.food_order_confirmed);

      // Reset selection
      this.selectedFoodOrders = [];
      this.selectAll = false;

      // Open dialog
      this.printFoodOrderDialog = true;
    },

    toggleSelectAll(value) {
      if (value) {
        this.selectedFoodOrders = [...this.allFoodOrders];
      } else {
        this.selectedFoodOrders = [];
      }
    },

    printSelectedKitchenOrders() {
      if (this.selectedFoodOrders.length > 0) {
        this.printKitchenOrder(this.selectedFoodOrders);
        this.printFoodOrderDialog = false;
      }
    },
    printKitchenOrder(foodOrders) {
      // Group orders by category for better kitchen organization
      const ordersByCategory = {};
      foodOrders.forEach(order => {
        if (!ordersByCategory[order.category]) {
          ordersByCategory[order.category] = [];
        }
        ordersByCategory[order.category].push(order);
      });

      // Prepare the payload for kitchen printer
      const payload = {
        print_type: 'FOOD',
        kitchen_data: {
          // Kitchen order metadata
          customer_name: this.customer.name,
          staff_name: this.customer.staff_name || 'Staff',
          timestamp: new Date().toISOString(),
          total_items: foodOrders.length,

          // Organize orders by category
          categories: Object.keys(ordersByCategory).map(categoryName => ({
            category_name: categoryName,
            items: ordersByCategory[categoryName].map(order => ({
              name: order.name,
              qty: order.qty,
              table_number: order.table_number || null,

              // Include extras from the order
              extras: order.extras || [],

              // Include product tags
              product_tags: order.product_tags || [],

              // Include options
              options: order.options || null,

              // Order ID for reference
              order_id: order.id
            }))
          })),

          // Flat list of all items for easy printing
          all_items: foodOrders.map(order => ({
            category: order.category,
            name: order.name,
            qty: order.qty,
            table_number: order.table_number || null,
            extras: order.extras || [],
            product_tags: order.product_tags || [],
            options: order.options || null,
            order_id: order.id
          }))
        },

        // Additional metadata
        source: 'kitchen_orders',
        customer_id: this.customer.id,
        staff_id: this.staff_id
      };

      // Show loading notification
      this.show_flash = true;
      this.flash_message = 'Sending kitchen orders to printer...';

      // Send to Django API
      this.$http.post(
          this.$http.defaults.baseURL + '/printer/send',
          payload
      ).then((response) => {
        console.log('Kitchen print response:', response.data);

        if (response.data.success) {
          this.show_flash = true;
          this.flash_message = response.data.snackbar_message || 'Kitchen orders sent to printer successfully!';
        } else {
          this.show_flash = true;
          this.flash_message = response.data.snackbar_message || 'Failed to send kitchen orders to printer';
        }
      }).catch((error) => {
        console.error('Kitchen print error:', error);

        let errorMessage = 'Failed to send kitchen orders to printer';

        if (error.response && error.response.data && error.response.data.snackbar_message) {
          errorMessage = error.response.data.snackbar_message;
        } else if (error.response && error.response.status === 403) {
          errorMessage = 'Authentication failed - invalid API key';
        } else if (error.response && error.response.status === 400) {
          errorMessage = 'Invalid request - check kitchen order data';
        } else {
          errorMessage = 'Network error - could not connect to printer service';
        }

        this.show_flash = true;
        this.flash_message = errorMessage;
      });
    },
    confirm_food_orders(customer) {
      this.$http.post(
          this.$http.defaults.baseURL + '/staff/confirm-food-orders/', {
            staff_id: this.staff_id,
            customer_id: this.customer_id,
          }).then((response) => {
          this.load_customer(this.customer_id)
      })
          .catch((error) => {
            this.notification = true;
            this.notification_message = 'Error: Please contact administrator';
          });

    },
    getOrderDetails(order_id) {
      const order = this.cart_items.find(o => o.id === order_id)
      if (!order) {
        return {
          orderId: null,
          tags: [],
          extras: [],
          table_number: null
        }
      }
      return {
        orderId: order_id,
        tags: order.product_tags,
        extras: order.extras,
        table_number: order.table_number,
      }
    },
    openTableDialog(order_id) {
      this.selected_order_id = order_id;
      this.selectedCartItem = this.getOrderDetails(order_id)
      this.table_dialog = true;
    },
    saveExtras(selectedCartItem) {
      if (!selectedCartItem) {
        console.log('Error');
        this.notification = true;
        this.notification_message = 'Error: Please contact administrator';
        return;
      }
      const extras_string = this.tags_obj_to_string(selectedCartItem.extras);
      this.$http.post(
          this.$http.defaults.baseURL + '/staff/order/' + this.selected_order_id + '/', {
            table_number: selectedCartItem.table_number,
            tags: extras_string
          }).then((response) => {
        this.cart_items.find(s => s.id === this.selected_order_id).table_number = selectedCartItem.table_number;
        this.cart_items.find(s => s.id === this.selected_order_id).extras = selectedCartItem.extras;
        this.cart_items.find(s => s.id === this.selected_order_id).price = response.data.price;
        this.re_calculate_order_total();
        this.table_dialog = false;
      })
          .catch((error) => {
            this.notification = true;
            this.notification_message = 'Error: Please contact administrator';
          });
    },
    delete_free_drink(item) {
      console.log('delete');
      console.log(item);
      this.$http.delete(
          this.$http.defaults.baseURL + '/staff/free-drinks/' + item.id + '/').then((response) => {
        this.load_customer(this.customer_id)
      })
          .catch((error) => {
            this.notification = true;
            this.notification_message = 'Error: Please contact administrator';
            console.log("Error");
            console.log(error);
          });
    },
    delete_order(item) {
      if (!confirm('Are you sure you want to delete?')) {
        return;
      }

      this.$http.delete(
          this.$http.defaults.baseURL + '/staff/order-lines/' + item.id + '/').then((response) => {
        this.load_customer(this.customer_id)

      }).catch((error) => {
        this.notification = true;
        this.notification_message = 'Error: Please contact administrator';
        console.log("Error");
        console.log(error);
      });
    },
    load_customers() {
      this.$router
          .push({path: '/c-panel/customers/' + this.staff_id + '/'})
    },
    go_back(category) {
      this.qty = 1;
      if (this.sizes.length || this.mixes.length) {
        this.sizes = [];
        this.mixes = [];
        this.load_categories({id: category.parent});
        return false;
      }
      this.history = [];
      this.selected_category = '';
      this.load_categories({})
    },
    load_attributes(product) {
      this.sizes = product.sizes;
      this.mixes = product.mixes;
      this.selected_category.name = product.name;
    },
    submitProductWithOptions() {
      // Get options from the computed property
      const optionsData = this.selectedOptions;

      // Make sure we have options to work with
      if (!optionsData || !optionsData.length) {
        // No options to select, can proceed directly
        let send_data = {
          customer: this.customer.id,
          product: this.current_product.id,
          qty: this.qty,
          staff: this.staff_id,
          attribute_value: null,
          options: null
        };
        this.add_to_order(send_data);
        this.showOptionsDialog = false;
        return;
      }

      // Clear previous error message
      this.optionSelectionError = null;

      // Validate that all required steps have a selection
      const allStepsSelected = optionsData.every(
          step => this.option_selections[step.step] !== undefined
      );

      if (!allStepsSelected) {
        // Show an error message if not all steps have a selection
        this.optionSelectionError = "Please select an option for each section";
        return;
      }

      // Format the selected options as a string
      let formattedOptions = Object.entries(this.option_selections)
          .map(([stepIndex, option]) => {
            // Check if option exists and has a name property
            if (!option || typeof option.name === 'undefined') {
              return null;
            }

            // Find the correct step by its 'step' property value
            const step = optionsData.find(
                s => s.step.toString() === stepIndex.toString()
            );

            // Include the section title in the formatted string
            return `${parseInt(stepIndex) + 1}: ${step ? step.title : 'Option'} - ${option.name}`;
          })
          .filter(Boolean) // Remove any null entries
          .join(', ');

      // Create the data object to send
      let send_data = {
        customer: this.customer.id,
        product: this.current_product.id,
        qty: this.qty,
        staff: this.staff_id,
        attribute_value: null,
        options: formattedOptions
      };

      // Add to order and close the dialog
      this.add_to_order(send_data);
      this.showOptionsDialog = false;
    },
    add_product_to_cart(product) {
      const show_options = product.options && product.options.length;

      if (show_options) {
        // Initialize selected options for each step
        this.option_selections = {};
        this.current_product = product;

        // Add this code to initialize default selection for each option group
        if (product.options && product.options.length) {
          product.options.forEach(section => {
            if (section.options && section.options.length) {
              // Set the first option as default for each section
              this.option_selections[section.step] = section.options[0];
            }
          });
        }

        this.showOptionsDialog = true;
      } else {
        // No options needed, proceed with standard add to cart
        let send_data = {
          customer: this.customer.id,
          product: product.id,
          qty: this.qty,
          staff: this.staff_id,
          attribute_value: null,
          options: null
        };
        this.add_to_order(send_data);
      }
    },
    add_attribute_to_cart(attr) {
      console.log('ADD ATTR');
      let send_data = {
        customer: this.customer.id,
        product: attr.product_id,
        qty: this.qty,
        staff: this.staff_id,
        attribute_value: attr.id
      };
      this.add_to_order(send_data);
    },
    load_products(cat) {
      this.category = cat;
      this.product_dialog = true;
    },
    load_category_history(item) {
      if (!item.id) {
        this.history = [];
        this.selected_category = item;
        this.categories = this.base_categories;
        return;
      }
      this.selected_category = item;
      this.categories = item.categories;
    },
    load_categories(selected_cat) {
      // Check if the category already exists in history by ID
      const isDuplicate = this.history.some(item => item.id === selected_cat.id);
      this.selected_category = selected_cat;

      let filter_url = '';
      if (typeof selected_cat.id !== "undefined") {
        filter_url = '?parent=' + selected_cat.id;
      }
      this.$http.get(
          this.$http.defaults.baseURL + '/staff/categories/' + filter_url).then((response) => {
        this.categories = response.data;
        if (typeof this.customer.id === 'undefined') {
          this.load_customer(this.customer_id);
        }
        if (typeof selected_cat !== 'string') {
          selected_cat.categories = response.data;
          // Only add to history if it's not a duplicate
          if (!isDuplicate) {
            this.history.push(selected_cat);
          }
        }

        if (!selected_cat.id) {
          this.base_categories = response.data;
        }
      })
          .catch((error) => {
            this.notification = true;
            this.notification_message = 'Error: Please contact administrator';
            console.log("Error");
            console.log(error);
          });
    },
    build_tags_obj(tag_string) {
      /**
       * Gets the tag string and creates
       * an array of objects from it.
       *
       * Example Str: Cheese:4,Extra Bacon:2 or null
       */
      if (!tag_string || typeof tag_string !== 'string') {
        return [];
      }
      try {
        const availableTags = [];
        const tagArray = tag_string.split(',');
        tagArray.forEach(tag => {
          // Trim whitespace
          tag = tag.trim();

          // Check if the tag has a colon (indicating it has an amount)
          if (tag.includes(':')) {
            console.log(`TRY SPLIT: ${tag}`);
            // Split by colon to separate name and amount
            const [name, amount] = tag.split(':');
            // Add to availableTags as an object with name and amount
            availableTags.push({
              name: name.trim(),
              // Convert amount to number
              amount: parseInt(amount, 10)
            });
          } else {
            // If there's no colon, assume amount is 0
            availableTags.push({
              name: tag,
              amount: 0
            });
          }
        });
        return availableTags;
      } catch (error) {
        console.log(error);
        console.log(tag_string);
        return [];
      }
    },
    tags_obj_to_string: function (tagsArray) {
      /**
       * Converts an array of tag objects back into a tag string.
       *
       * Example: [{ name: 'Cheese', amount: 4 }, { name: 'Extra Bacon', amount: 2 }]
       * → "Cheese:4,Extra Bacon:2"
       */
      if (!Array.isArray(tagsArray) || tagsArray.length === 0) {
        return '';
      }

      return tagsArray
          .map(function (tag) {
            let name = (tag && tag.name) ? tag.name.trim() : '';
            let amount = (tag && typeof tag.amount === 'number') ? tag.amount : 0;
            return name + ':' + amount;
          })
          .join(',');
    },
    re_calculate_order_total() {
      console.log(this.cart_items);
      let total = 0;
      this.cart_items.forEach(item => {
        console.log(item);
        total += item.price * item.qty;
      });
      this.total_cart = total.toFixed(2);
    },
    load_customer(id) {
      /**
       * Load the current cart items
       */
      this.$http.get(
          this.$http.defaults.baseURL + '/staff/customers/' + id + '/').then((response) => {
        this.customer = response.data;
        let self = this;
        let order = {};
        this.total_cart = 0;
        this.cart_items = [];
        this.order_freebies = [];
        response.data.orders.forEach(function (o, i) {
          let hour_diff = parseInt(self.get_date_diff(new Date(o.created_at)));
          if (o.price === 0) {
            order = self.order_freebies.find(s => s.name === o.product.category.name + ' ' + o.product.name);
            if (typeof order === 'undefined') {
              self.order_freebies.push({
                category: o.product.category.name,
                name: o.product.name,
                qty: o.qty,
                price: o.price,
                id: o.id,
                hour_diff: hour_diff,
                extras: self.build_tags_obj(o.tags),
                product_tags: self.build_tags_obj(o.product.tags),
                options: o.options,
                is_food_order: o.is_food_order,
                food_order_confirmed: o.food_order_confirmed,
              });
            } else {
              order.qty += 1;
              order.price += o.price;
              order.extras = self.build_tags_obj(o.tags);
              order.product_tags = self.build_tags_obj(o.product.tags);
              order.options = o.options;
              order.is_food_order = o.is_food_order;
              order.food_order_confirmed = o.food_order_confirmed;
            }
          } else {
            order = self.cart_items.find(s => s.name === o.product.category.name + ' ' + o.product.name);
            if (typeof order === 'undefined') {
              self.cart_items.push({
                id: o.id,
                category: o.product.category.name,
                name: o.product.name,
                qty: o.qty,
                price: o.price,
                table_number: o.table_number,
                hour_diff: hour_diff,
                extras: self.build_tags_obj(o.tags),
                product_tags: self.build_tags_obj(o.product.tags),
                options: o.options,
                is_food_order: o.is_food_order,
                food_order_confirmed: o.food_order_confirmed
              });
            } else {
              order.qty += 1;
              order.price += o.price;
              order.extras = self.build_tags_obj(o.tags);
              order.product_tags = self.build_tags_obj(o.product.tags);
              order.options = o.options;
              order.is_food_order = o.is_food_order;
              order.food_order_confirmed = o.food_order_confirmed;
            }
          }
          self.total_cart += o.price;
        });
        this.free_items = response.data.free_drinks;
      })
          .catch((error) => {
            this.notification = true;
            this.notification_message = 'Error: Please contact administrator';
            console.log("Error");
            console.log(error);
          });
    },
    load_orders(customer) {
      this.$router
          .push({path: '/c-panel/orders/' + this.staff_id + '/' + customer.id})
    },
    get_date_diff(date) {
      return Math.abs(new Date() - date) / 36e5;
    },
    add_to_order(send_data) {

      this.overlay = true;
      this.cart_count = this.cart_count + 1;
      this.$http.post(this.$http.defaults.baseURL + '/staff/order-lines/', send_data)
          .then((response) => {
            this.show_flash = true;
            this.flash_message = 'Successfully added to cart';
            this.flash_type = 'success';
            this.load_customer(this.customer_id);
            this.overlay = false;
          })
          .catch((error) => {
            console.log("page error");
            console.log(error);
            this.overlay = false;
          });
    },
  }
}
</script>
